export default {
    loading: `正在載入驗證碼 ···`,
    init: `正在初始化驗證碼 ···`,
    click: `點擊按鈕進行驗證`,
    checking: `智能檢測中 ···`,
    pass: `通過驗證`,
    tip: `錯誤提示`,
    error: {
        try: `已連續錯誤達 {num} 次，請稍候再試`,
        init: `初始化介面有誤，請稍候再試`
    },
    move: `請移動滑桿，完成驗證`,
    drag: `拖曳左邊滑桿完成上方拼圖`,
    dragging: `拖曳滑桿將懸浮影像正確拼合`,
    close: `關閉驗證`,
    refresh: `刷新驗證`,
    feedback: `幫助回饋`,
    provide: `「 makeit.vip 」提供技術支援`,
    success: `{take}s速度完成圖片拼合驗證`,
    flatten: `拖曳滑桿拼合圖片`,
    verify: `就能驗證成功哦`
}
